import type { OmuiNumberStepperComponent } from '../../../NumberStepper'

export const OmuiNumberStepper: OmuiNumberStepperComponent = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      display: 'inline-flex',
      alignItems: 'stretch',
      borderRadius: 10,
      border: `1px solid ${ownerState?.error ? theme.palette.error.main : theme.palette.divider}`,
      overflow: 'hidden',
      height: 36,
      '&:focus-within': {
        borderColor: ownerState?.error ? theme.palette.error.main : theme.palette.primary.main,
        outline: `1px solid ${ownerState?.error ? theme.palette.error.main : theme.palette.primary.main}`,
      },
    }),
    input: ({ theme }) => ({
      flex: 1,
      '&& .MuiInputBase-input': {
        paddingTop: theme.spacing(0.75),
        paddingBottom: theme.spacing(0.75),
        paddingLeft: theme.spacing(3),
        paddingRight: 0,
        ...theme.typography.Body14pxRegular,
        textAlign: 'left',
        minWidth: 0,
      },
    }),
    button: ({ theme }) => ({
      borderRadius: 0,
      padding: theme.spacing(1),
      color: theme.palette.text.secondary,
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    }),
  },
}
